export const AUTH_LABELS = {
    signInTitle: "UA-GIS Trek:Вхід",
    username: "Логін",
    password: "Пароль",
    login: "Логін",
    signIn: "Увійти",
    accountCode: "Користувач",
    logOut: "Вийти",
    loggedIngMessage: "Ви успішно увійшли!",
    logOutMessage: "Ви успішно вийшли з Перевізнику!",
    language: "Мова",
    backgroundColor: "Колір фону",
    dayMap: "Денна карта",
    nightMap: "Нічна карта",
    demo: "Відкрити демо",
    or: "або",
    forgotPassword: "Забули пароль?",
    forgotPasswordHint: "Для відновлення паролю зверніться до менеджера",
    taglineTitle: "GPS-моніторинг та диспетчеризація",
    taglineText: "Комплексна система управління транспортом у режимі реального часу.",
    formTitle: "Вхід до системи",
    formSubtitle: "Введіть дані, які видав вам менеджер",
    errorCredentials: "Невірний логін, користувач або пароль. Або доступ вимкнено — тоді зверніться до менеджера.",
    errorUnavailable: "Сервер не відповідає. Спробуйте ще раз за хвилину.",
    trackPosition: "Позиція на треку",
    scoreTitle: "ППО",
    defenceOn: "Увімкнути режим ППО",
    disclaimerTitle: "Режим ППО",
    disclaimerText: "Це жартівлива міні-гра й пасхалка від автора. Вона містить політичну сатиру. Автор не мав на меті нікого образити чи принизити: тут лише гумор і повага до тих, хто захищає наше небо.",
    disclaimerQuestion: "Почати гру?",
    disclaimerCancel: "Скасувати",
    disclaimerStart: "Почати гру",
    rewardTitle: "{{count}} збито!",
    rewardCoffin: "Путін у труні. Чорт повернувся в пекло.",
    rewardKremlin: "Кремль палає. ППО працює.",
    rewardBavovna: "По всій росії — бавовна.",
    rewardCollapse: "Росія розпалась на шматки.",
    rewardSunk: "Росія зникла з мапи. У світі мир.",
    gloryToUkraine: "Слава Україні!",
    rewardClose: "Закрити",
    defenceOff: "Вимкнути режим ППО",
    scoreShaheds: "шахеди",
    scoreJets: "реактивні",
    scoreDrones: "дрони",
}